import { render, staticRenderFns } from "./fictitiousmeter.vue?vue&type=template&id=0c537c00&"
import script from "./fictitiousmeter.vue?vue&type=script&lang=ts&"
export * from "./fictitiousmeter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fictitiousmeter.vue"
export default component.exports